var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.132,
    height: 7.761,
    viewBox: "0 0 12.132 7.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#979797;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -96.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 96.07)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.331,97.9a8.916,8.916,0,0,0-1.882-1.244,5.508,5.508,0,0,0-2.382-.581,5.508,5.508,0,0,0-2.382.581A8.918,8.918,0,0,0,7.8,97.9a11.525,11.525,0,0,0-1.718,1.8.437.437,0,0,0,0,.515,11.522,11.522,0,0,0,1.718,1.8,8.916,8.916,0,0,0,1.882,1.244,5.508,5.508,0,0,0,2.382.581,5.509,5.509,0,0,0,2.382-.581,8.918,8.918,0,0,0,1.882-1.244,11.525,11.525,0,0,0,1.718-1.8.437.437,0,0,0,0-.515A11.524,11.524,0,0,0,16.331,97.9Zm-4.264,5.063c-2.371,0-4.431-2.236-5.072-3.007.641-.772,2.7-3.007,5.072-3.007s4.431,2.235,5.072,3.007C16.5,100.722,14.437,102.958,12.067,102.958Z",
    transform: "translate(-6 -96.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M167.208,165a2.208,2.208,0,1,0,2.208,2.208A2.211,2.211,0,0,0,167.208,165Zm0,3.543a1.335,1.335,0,1,1,1.335-1.335A1.336,1.336,0,0,1,167.208,168.543Z",
    transform: "translate(-161.142 -163.327)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.cae787e6434395d1daaf36c8fde4a137.svg";
export { ForwardRef as ReactComponent };